<template>

    <LoopItemPanel title="Slide">

        <div class="shop::canvas-blocks-shop-products-LoopItemPanel">

        </div>

    </LoopItemPanel>

</template>

<script>

import LoopItemPanel from "@galaxy/modules/Canvas/resources/js/editor/website/editors/loop/owlCarousel/LoopItemPanel";
import Treeselect from '@riophae/vue-treeselect';
import axios from '@galaxy/modules/Core/resources/js/axiosBuilder';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';

export default {

    extends: LoopItemPanel,

    components: {
        LoopItemPanel,
    },

}
</script>

<style lang="scss" scoped>

.shop\:\:canvas-blocks-shop-products-LoopItemPanel {

}

</style>
